import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";

interface RestockDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  selectedItem: any;
  restockQuantity: string;
  onQuantityChange: (value: string) => void;
  onConfirm: (quantity: number) => void;
}

export const RestockDialog = ({
  open,
  onOpenChange,
  selectedItem,
  restockQuantity,
  onQuantityChange,
  onConfirm,
}: RestockDialogProps) => {
  const isQuantityValid = restockQuantity && parseInt(restockQuantity) > 0;

  const handleConfirm = () => {
    const quantity = parseInt(restockQuantity);
    if (quantity > 0) {
      onConfirm(quantity);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            Réapprovisionnement - {selectedItem?.data?.name}
          </DialogTitle>
          <DialogDescription>
            Ajoutez la quantité que vous souhaitez ajouter au stock.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <label
              htmlFor="quantity"
              className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
            >
              Quantité à ajouter
            </label>
            <Input
              id="quantity"
              type="number"
              value={restockQuantity}
              onChange={(e) => onQuantityChange(e.target.value)}
              placeholder="Entrez la quantité"
              min="1"
            />
            <p className="text-sm text-muted-foreground">
              Stock actuel: {selectedItem?.quantity || 0} {selectedItem?.data?.unit || 'unités'}
            </p>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Annuler
          </Button>
          <Button 
            onClick={handleConfirm}
            disabled={!isQuantityValid}
          >
            Confirmer
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};